import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SubmitCashbackForm } from '@features/cashback/store/actions/cashback.actions';
import * as pointsTransferActions from '@features/transfer-connect-v2/store/actions/checkout.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

@Injectable()
export class FormSubmissionEffects {
  constructor(private actions$: Actions, private router: Router) {}

  cashBackFormSubmission$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SubmitCashbackForm),
        tap(() => {
          this.router.navigateByUrl('redeem_cash/checkout/enrollment');
        }),
      ),
    { dispatch: false },
  );

  pointsTransferSubmission$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          pointsTransferActions.CheckoutActionTypes.SUBMIT_CHECKOUT_FORM_DATA,
        ),
        tap((action: pointsTransferActions.SubmitPointsTransfer) => {
          this.router.navigate(
            [
              `/transfer/checkout/${action.payload.loyaltyProgramId}/membership`,
            ],
            {
              queryParams: {
                loyaltyProgramId: action.payload.loyaltyProgramId,
              },
            },
          );
        }),
      ),
    { dispatch: false },
  );
}
